import { createApi } from "@reduxjs/toolkit/query/react";
import { getDeviceId, queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const authApiService = createApi({
  reducerPath: "authApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    login: builder.mutation({
      query: ({ payload, params }) => {
        const query = queryParams(params);
        return {
          url: `auth/all/login${query}`,
          method: "POST",
          body: {
            ...payload,
            // deviceId: localStorage.getItem("device_token"),
            device_id: getDeviceId(),
          },
        };
      },
    }),
    forgetPassword: builder.mutation({
      query: ({ payload, params }) => {
        const query = queryParams(params);
        return {
          url: `auth/sendotp${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    verifyOtp: builder.mutation({
      query: ({ payload, params }) => {
        const query = queryParams(params);
        return {
          url: `auth/verify-otp${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    resetPassword: builder.mutation({
      query: ({ payload, params }) => {
        const query = queryParams(params);
        return {
          url: `auth/reset-password${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    logout: builder.mutation({
      query: ({ params }) => {
        const query = queryParams(params);
        return {
          url: `auth/logout${query}`,
          method: "GET",
        };
      },
    }),
    connectStripe: builder.mutation({
      query: ({ payload, params }) => {
        const query = queryParams(params);
        return {
          url: `auth/connect/onboard${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    connectHistory: builder.mutation({
      query: ({ params }) => {
        const query = queryParams(params);
        return {
          url: `auth/connect/manage${query}`,
          method: "POST",
        };
      },
    }),
  }),
});

export const {
  useLoginMutation,
  useForgetPasswordMutation,
  useVerifyOtpMutation,
  useResetPasswordMutation,
  useLogoutMutation,
  useConnectStripeMutation,
  useConnectHistoryMutation,
} = authApiService;
